import React from 'react';
import { connect } from 'react-redux';
import urls, { codeUrl } from '@/constants/urls';
import paging, { onCategoryScroll, reFetchConfig } from '@/hooks/paging';
import UserGroupsPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/UserGroupsPanelContainer';
import UserGroupCards from '../components/UserGroupCards';
import UserGroupsFilters from './UserGroupsFilters';

const UserGroupsPanelNarrow = ({
  canCreate,
  canRead,
  category,
  currentPage,
  fetchData,
  newUserGroupCode,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  usergroups,
  total,
}) => {
  paging.useFetchByCategory(
    fetchData,
    category,
    readStatus,
    reFetchConfig(usergroups, { pageSize, total }, [category]),
  );
  return (
    <UserGroupsPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-usergroups-panel-narrow">
      <div className="sticky-panel-header">
        <UserGroupsFilters category={category} className="aridhia-list-filter" fluid />
      </div>
      <UserGroupCards
        canCreate={canCreate}
        handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
        items={usergroups}
        itemsPerRow={1}
        onCheckBoxClick={(value) => onCheckBoxClick(category, value)}
        readErrors={readErrors}
        readStatus={readStatus}
        url={codeUrl(urls.USER_GROUP, newUserGroupCode, '#')}
      />
    </UserGroupsPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupsPanelNarrow);
